import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import { captureException } from '../lib/sentry';
import { log } from '../lib/logger';
import { translations } from './translations';
export const i18n = i18next.createInstance();
i18n
    .use(ICU)
    .use(initReactI18next)
    .init({
    resources: translations,
    fallbackLng: 'en-US',
    nsSeparator: false,
    keySeparator: false,
    ns: [],
    defaultNS: 'translation',
    debug: false,
    interpolation: {
        escapeValue: false,
    },
})
    .catch(exc => {
    captureException(exc);
    log.error(exc);
});
